module.exports = __webpack_public_path__ + "static/img/TN@2x.cf926aa3.jpg";